import React from 'react'

import HelpPopover from './HelpPopover'

export const OverallHelp = (
  <HelpPopover id="overall_stats" title="Overall Statistics">
    <span>
      <p>
        <strong> At-Risk Students</strong>: Below 60% average assessment score.{' '}
        <sup>*</sup>
      </p>
      <p>
        <strong> Average Students</strong>: Between 60% and 80% average
        assessment score. <sup>*</sup>
      </p>
      <p>
        <strong> Excellent Students</strong>: Above 80% average assessment
        score. <sup>*</sup>
      </p>
    </span>
  </HelpPopover>
)

export const StudentPerfHelp = (
  <HelpPopover id="student_perf_stats" title="Student Performance">
    <p>
      This graph shows a student&apos;s performance on assessments compared to
      the student&apos;s level of engagement across all available course
      content.
    </p>
  </HelpPopover>
)

export const AssessmentPerfHelp = (
  <HelpPopover id="assessment_perf_stats" title="Assessment Performance">
    <p>
      The tables below show the assessments with the best and worst average
      scores. Clicking on an assessment will show you a question-by-question
      breakdown of the assessment.
    </p>
  </HelpPopover>
)

export const EngagementHelp = (
  <HelpPopover id="class_engage_stats" title="Class Engagement">
    <p>
      These charts show average reading, video, and assessment completion among
      all students in all content.
    </p>
  </HelpPopover>
)

export const ClassPerfHelp = (
  <HelpPopover id="class_perf_stats" title="Class Performance">
    <p>
      This graph shows groupings of students based on current average assessment
      performance.
    </p>
  </HelpPopover>
)
